export default {
    methods: {
        getURLParameter(name) {
            const queryString = window.location.search;
            return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.search) || [null, ''])[1].replace(/\+/g, '%20')) || null;
        },
        getUrlVars() {
            var vars = {};
            var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m,key,value) {
                vars[key] = value;
            });
            return vars;
        },
        getUrlParam(parameter, defaultvalue) {
            var urlparameter = defaultvalue;
            if(window.location.href.indexOf(parameter) > -1){
                urlparameter = this.getUrlVars()[parameter];
                }
            return urlparameter;
        },
        isValidJSONString(str) {
            try {
                JSON.parse(str);
            } catch (e) {
                return false;
            }
            return true;
        },
        checkParameters(params, query=null) {
            if (this.addParamsToUrl) {
                let localStorage = window.localStorage;

                Object.keys(params).forEach( key => {
                    let param = params[key];
                    let value = null;
                    if(query){
                        value = query[param];
                    }else{
                        value = this.getURLParameter(param);
                    }
                    if (value) {
                        if (! isNaN(value)) {
                            this.tableProps[key] = Number(value);
                        }
                        else if (this.isValidJSONString(value)) {
                            let f = JSON.parse(value);
                            Object.keys(f).forEach( f_key => {
                                this.tableProps[key][f_key] = f[f_key];
                            });
                        }else{
                            this.tableProps[key] = value;
                        }
                    }
                    else if (this.addParamsToLocalStorage && localStorage.getItem(this.$options.name + "_" + param)){
                        let value = localStorage.getItem(this.$options.name + "_" + param);

                        if (! isNaN(value)) {
                            this.tableProps[key] = Number(value);
                        }
                        else if (this.isValidJSONString(value)) {
                            let f = JSON.parse(value);
                            Object.keys(f).forEach( f_key => {
                                this.tableProps[key][f_key] = f[f_key];
                            });
                        }else{
                            this.tableProps[key] = value;
                        }
                    }
                });
                //this.updateParameters(params);
            }
        },
       
        updateParameters(params,replaceHistory = false) {
            const query = {};

            Object.keys(params).forEach(key => {
                let value = typeof params[key] === "object" ? JSON.stringify(params[key]) : params[key];

                if (this.addParamsToLocalStorage) {
                    window.localStorage.setItem(this.$options.name + "_" + key, value);
                }

                query[key] = value;
            });

            // Se for igual ao que já está na rota, não faz push
            if (JSON.stringify(this.$route.query) !== JSON.stringify(query)) {
                 if (replaceHistory) {
                     this.$router.replace({ query }).catch(err => {
                         if (err.name !== "NavigationDuplicated") throw err;
                     });
                 } else {
                     this.$router.push({ query }).catch(err => {
                         if (err.name !== "NavigationDuplicated") throw err;
                     });
                 }
            }

        }
        
    }
}